<template>
  <div>
    <h1>关于我</h1>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="less" scoped>

</style>